<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="list mtb80">
                    <div class="table">
                        <table>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>구분</th>
                                    <th>내용</th>
                                    <th>적립/차감</th>
                                    <th>잔액</th>
                                    <th>등록일</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in list" :key="row.id">
                                    <td>
                                        {{ pagination.total - ((pagination.current_page - 1) * pagination.per_page) - index }}
                                    </td>
                                    <td>{{ row.type === 'minus' ? '차감' : row.type === 'plus' ? '충전' : row.type }}</td>
                                    <td>{{ row.description || '-' }}</td>
                                    <td
                                      :class="row.price >= 0 ? 'blue_f' : 'red_f'">
                                        {{ row.price.toLocaleString() }}
                                    </td>
                                    <td>{{ row.balance.toLocaleString() }}</td>
                                    <td>{{ formatDate(row.created_at) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- pagination -->
                    <div class="pagination" v-if="pagination && pagination.last_page > 1">
                        <a href="#" class="prev"
                           v-if="pagination.current_page > 1"
                           @click.prevent="goPage(pagination.current_page - 1)">
                            ‹
                        </a>

                        <a href="#"
                           v-for="p in pagination.last_page"
                           :key="p"
                           :class="{ active: p === pagination.current_page }"
                           @click.prevent="goPage(p)">
                            {{ p }}
                        </a>

                        <a href="#" class="next"
                           v-if="pagination.current_page < pagination.last_page"
                           @click.prevent="goPage(pagination.current_page + 1)">
                            ›
                        </a>
                    </div>
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>
<script>
import api from '@/api'
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
    name: 'PointHistory',
    components: { TheHeader, TheFooter },

    data() {
        return {
            user: null,
            list: [],
            pagination: null,
            page: 1
        }
    },

    mounted() {
        this.checkLoginAndLoad()
    },

    methods: {
        async checkLoginAndLoad() {
            try {
                const res = await api.get('/admin/user-info', {
                    withCredentials: true
                })

                if (!res.data.loggedIn) {
                    this.redirectLogin()
                    return
                }

                this.user = res.data.user
                this.loadPointHistory()
            } catch (e) {
                this.redirectLogin()
            }
        },

        redirectLogin() {
            const referer = this.$route.fullPath
            window.location.href =
                `/login_form?referer=${encodeURIComponent(referer)}`
        },

        async loadPointHistory() {
            const res = await api.get('/admin/vue_point_history', {
                params: {
                    userid: this.user.id,
                    page: this.page
                },
                withCredentials: true
            })

            this.list = res.data.data || []
            this.pagination = res.data
        },

        formatDate(date) {
            return date ? date.substring(0, 10) : '-'
        },

        goPage(page) {
            if (page < 1 || page > this.pagination.last_page) return
            this.page = page
            this.loadPointHistory()
        }
    }
}
</script>   